module.exports = __webpack_public_path__ + "assets/img/process-4.b992282e.png";